import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    rowGap: theme.spacings.md,
    padding: theme.spacings.md,
    backgroundColor: theme.colors.white,
  },
  filterRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: theme.spacings.sm,
  },
  labelQuarter: {
    flexBasis: '25%',
    fontSize: theme.fontSizes.base,
    fontWeight: 'bold',
  },
  radioGroup: {
    flexDirection: 'row',
    columnGap: theme.spacings['2xl'],
  },
  radioItem: {
    alignItems: 'flex-start',
  },
  checkboxRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacings.sm,
  },
});
